import history from '../../util/history'

const toInvoiceTabView = (basePath, reservationId) => {
  history.replace(`${basePath}/${reservationId}/invoices`)

  return true
}

export default toInvoiceTabView
